import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=2e77ddc7&"
import script from "./HistoryList.vue?vue&type=script&lang=js&"
export * from "./HistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VChip,VTimeline})
